import { render, staticRenderFns } from "./AddAttribute.vue?vue&type=template&id=680a46bc&scoped=true&"
import script from "./AddAttribute.vue?vue&type=script&lang=js&"
export * from "./AddAttribute.vue?vue&type=script&lang=js&"
import style0 from "./AddAttribute.vue?vue&type=style&index=0&id=680a46bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680a46bc",
  null
  
)

export default component.exports